export default __webpack_public_path__ + "static/media/editar2.554b8515.svg";